import {Injectable} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Address} from '../interface/address';
import {of} from 'rxjs';
import {delay, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FormHelperService {

  constructor(
    private fb: FormBuilder,
  ) { }

  public setBackendErrorState(formGroup: FormGroup, errors: object): void {
    of('')
      .pipe(
        tap(() => {
          for (const [key, value] of Object.entries(errors)) {
            formGroup.get(key).setErrors({backendError: value});
          }
        }),
        delay(0),
        tap(() => formGroup.markAllAsTouched())
      ).subscribe();
  }

  public removeBackendErrorState(formGroup: FormGroup, errors: object): void {
    for (const [key, value] of Object.entries(errors)) {
      formGroup.get(key).setErrors(null);
    }
  }

  public setAddress(address: Address, formGroup: FormGroup): void {
    formGroup.reset({
      street: address.street,
      houseNumber: address.houseNumber,
      apartmentNumber: address.apartmentNumber,
      city: address.city,
      zipCode: address.zipCode,
      state: address.stateId,
      postCity: address.postCity,
      district: address.district,
      commune: address.commune,
    });
  }

  public setPzuAddress(address: Address, formGroup: FormGroup): void {
    formGroup.reset({
      street: address.street,
      houseNumber: address.houseNumber,
      apartmentNumber: address.apartmentNumber,
      city: address.city,
      zipCode: address.zipCode,
      state: address.stateId,
      commune: address.commune,
      district: address.district,
    });
  }
  public generateAddressFormGroup(required = true, short = false, requirePzuData = false, foreignActivities = false): FormGroup {

    if (requirePzuData) {
      return this.fb.group({
        street: this.fb.control('', [Validators.required]),
        houseNumber: this.fb.control('', [Validators.required]),
        apartmentNumber: this.fb.control(''),
        city: this.fb.control('', [Validators.required]),
        zipCode: this.fb.control('', [Validators.required,
          Validators.minLength(6),
          Validators.pattern('^[0-9]{2,5}(:|\\-)?[0-9]{3,4}')]),
        state: this.fb.control('', [Validators.required]),
        postCity: this.fb.control('', [] ),
        district: this.fb.control('',  [Validators.required]),
        commune: this.fb.control('',  [Validators.required]),
      });
    } else if (required) {
      return this.fb.group({
        street: this.fb.control('', [Validators.required]),
        houseNumber: this.fb.control('', [Validators.required]),
        apartmentNumber: this.fb.control(''),
        city: this.fb.control('', [Validators.required]),
        zipCode: this.fb.control('', [Validators.required,
          Validators.minLength(6),
          Validators.pattern('^[0-9]{2,5}(:|\\-)?[0-9]{3,4}')]),
        state: this.fb.control('', requirePzuData ? [] : [Validators.required]),
        postCity: this.fb.control('', short ? [] : [Validators.required]),
        district: this.fb.control('', short ? [] : [Validators.required]),
        commune: this.fb.control('', short ? [] : [Validators.required]),
      });
    } else if (foreignActivities) {
      return this.fb.group({
        street: this.fb.control('', [Validators.required]),
        houseNumber: this.fb.control('', [Validators.required]),
        apartmentNumber: this.fb.control(''),
        city: this.fb.control('', [Validators.required]),
        zipCode: this.fb.control('-', []),
        state: this.fb.control('', []),
        postCity: this.fb.control('', []),
        district: this.fb.control('', []),
        commune: this.fb.control('', []),
      });
    } else{
      return this.fb.group({
        street: this.fb.control('', []),
        houseNumber: this.fb.control('', []),
        apartmentNumber: this.fb.control(''),
        city: this.fb.control('', []),
        zipCode: this.fb.control('', []),
        state: this.fb.control('', []),
        postCity: this.fb.control('', []),
        district: this.fb.control('', []),
        commune: this.fb.control('', []),
      });
    }
  }
}
